import { FormGroup, FormControl, Validators } from '@angular/forms';

export class DebugUtils {

  // 入力フォームの現在の状態をコンソールに出力する
  static dumpFormStructure(formGroup: any, name: string = 'root') {
    const getStructure = (ctrl: any, ctrlName: string): any => {
      const statusInfo = {
        name: ctrlName,
        status: ctrl.status,         // 'VALID', 'INVALID', 'DISABLED', 'PENDING'
        enabled: ctrl.enabled,       // true / false
        touched: ctrl.touched,
        // 💡 もし下位の特定のフォームグループ自体が disabled になっていないか確認するため
      };

      // FormGroup の場合（子コントロールを再帰処理）
      if (ctrl.controls && !Array.isArray(ctrl.controls) && typeof ctrl.controls === 'object') {
        const children: any = {};
        Object.keys(ctrl.controls).forEach(key => {
          children[key] = getStructure(ctrl.controls[key], key);
        });
        return { ...statusInfo, type: 'FormGroup', controls: children };
      }
      
      // FormArray の場合（配列の中身を再帰処理）
      if (ctrl.controls && Array.isArray(ctrl.controls)) {
        const children = ctrl.controls.map((childCtrl: any, index: number) => 
          getStructure(childCtrl, `[${index}]`)
        );
        return { ...statusInfo, type: 'FormArray', controls: children };
      }

      // 通常の FormControl の場合
      return { ...statusInfo, type: 'FormControl', value: ctrl.value };
    };

    // ブラウザのコンソールで折りたたみ展開ができるように綺麗に出力
    console.dir(getStructure(formGroup, name));
  }

  // 入力フォームのバリデーションの状態をコンソールに出力する
  static logFormErrors(formGroup: FormGroup, currentPath = ''): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      const path = currentPath ? `${currentPath}.${key}` : key;

      if (control instanceof FormGroup) {
        // 階層が FormGroup の場合はさらに深く掘り下げる（再帰）
        this.logFormErrors(control, path);
      } else if (control && control.invalid) {
        // FormControl 自体が invalid な場合はエラー内容をログ出力
        console.error(`🚨 バリデーションエラー箇所: [ ${path} ]`, control.errors);
      }
    });
  }
}